$(document).ready(function(){
    if (jQuery('.sortable-table-date').length){
        jQuery('.sortable-table-date').dataTable({
            "searching": false,
            "info": false,
            "order": [[ 3, "desc" ]],
            "paging": false,
        });
    }

    if (jQuery('.sortable-table').length){
        jQuery('.sortable-table').dataTable({
            "searching": false,
            "info": false,
            "order": [[ 0, "asc" ]],
            "paging": false,
        });
    }

    if (jQuery('.sortable-table-no-sort').length){
        jQuery('.sortable-table-no-sort').dataTable({
            "searching": false,
            "info": false,
            "paging": false,
            "aaSorting": []
        });
    }

});

//$.fn.dataTableExt.sErrMode = 'throw';